import React from "react";

const ProductOrderSummary = ({
  orderPrice,
  orderDiscount,
  orderTotal,
  handleAddToCart,
  handleCheckout,
  className = "",
}) => {
  return (
    <aside className={`pdp-order-card ${className}`.trim()}>
      <h2 className="pdp-order-title">Đơn hàng</h2>

      <div className="pdp-order-row">
        <p className="pdp-order-label">Giá tiền</p>
        <p className="pdp-order-value">{(orderPrice || 0).toLocaleString()}đ</p>
      </div>

      <div className="pdp-order-row">
        <p className="pdp-order-label">Giảm giá</p>
        <p className="pdp-order-value">{(orderDiscount || 0).toLocaleString()}đ</p>
      </div>

      <div className="pdp-order-total">
        <p className="pdp-order-total-label">Tổng</p>
        <p className="pdp-order-total-value">{(orderTotal || 0).toLocaleString()}đ</p>
      </div>

      <div className="pdp-order-actions">
        <button onClick={handleAddToCart} className="pdp-btn pdp-btn--muted">
          Thêm vào giỏ hàng
        </button>

        <button onClick={handleCheckout} className="pdp-btn pdp-btn--primary">
          Thanh toán ngay
        </button>
      </div>
    </aside>
  );
};

export default ProductOrderSummary;
